// Conteo de segmentos SMS igual que AWS End User Messaging.
// GSM-7 (latino basico): 1 segmento = 160 chars.
// UCS-2 (acentos/emojis): 1 segmento = 70 chars.
// Algunos chars GSM-7 extendidos (| ^ { } [ ] ~ \ €) cuentan como 2.

const GSM7_BASIC =
  '@£$¥èéùìòÇ\nØø\rÅå_ÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?' +
  '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà' +
  'ΔΦΓΛΩΠΨΣΘΞ';
const GSM7_EXTENDED = new Set(['^', '{', '}', '[', ']', '~', '\\', '|', '€']);

const LIMITE_GSM7 = 160;
const LIMITE_UCS2 = 70;

function esGsm7(texto) {
  for (const ch of texto) {
    if (!GSM7_BASIC.includes(ch) && !GSM7_EXTENDED.has(ch)) return false;
  }
  return true;
}

/**
 * Analiza un texto SMS.
 * @returns { encoding, limite, unidades, segmentos, excede }
 *   - encoding: 'GSM-7' | 'UCS-2'
 *   - limite: caracteres permitidos en 1 segmento
 *   - unidades: unidades consumidas por el texto
 *   - segmentos: cuantos segmentos requiere
 *   - excede: true si requiere mas de 1 segmento
 */
export function analizarSms(texto) {
  texto = texto || '';
  let unidades;
  let limite;
  let encoding;
  if (esGsm7(texto)) {
    unidades = 0;
    for (const ch of texto) unidades += GSM7_EXTENDED.has(ch) ? 2 : 1;
    limite = LIMITE_GSM7;
    encoding = 'GSM-7';
  } else {
    unidades = [...texto].length;
    limite = LIMITE_UCS2;
    encoding = 'UCS-2';
  }
  const segmentos = unidades === 0 ? 0 : unidades <= limite ? 1 : Math.ceil(unidades / limite);
  return {
    encoding,
    limite,
    unidades,
    segmentos,
    excede: segmentos > 1,
    restantes: Math.max(limite - unidades, 0),
  };
}
